import { render, staticRenderFns } from "./LessonsRatingTranslation.vue?vue&type=template&id=52a6497c"
import script from "./LessonsRatingTranslation.vue?vue&type=script&lang=js"
export * from "./LessonsRatingTranslation.vue?vue&type=script&lang=js"
import style0 from "./LessonsRatingTranslation.vue?vue&type=style&index=0&id=52a6497c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports